import { useState } from "react";
import axios from "axios";
import ChatWindow from "./../components/chat/ChatWindow";
import DemoModal from "./../demomodel";
import { Check, CheckCircle, MessageSquare, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PhoneInput } from "@/components/ui/phone-input";

import RetellCallDialog from "@/components/voice/RetellCallDialog";

import LivekitVoice from "@/components/voice/LivekitCallDialog";
import VoiceXCallDialog from "@/components/voice/VoiceXCallDialog";
import { DynamicVariables } from "@/components/ui/DynamicVariables";
import { CallFeedbackForm } from "@/components/ui/CallFeedbackForm";
import { Switch } from "@/components/ui/switch"
import { useDynamicVariablesQuery } from "@/components/hooks/useDynamicVariables.tsx";
import { useTtsConfigsQuery } from "@/components/hooks/useVoiceTtsConfigs.tsx";


import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"


export default function AgentCard({
  id,
  icon,
  chatIcon,
  categoryKey,
  name,
  agentName,
  voice,
  callHints,
  callHintsTable,
  chatHints,
  chat,
  featureList,
  voiceProvider,
  voiceConfig,
  voiceInputs
}) {
  const [selectedchatAgent, setSelectedchatAgent] = useState("");
  const [showChatWindow, setShowChatWindow] = useState(false);
  const [isCallActive, setIsCallActive] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [demovideoId, setDemovideoId] = useState("");
  const [isCallDialogOpen, setIsCallDialogOpen] = useState(false);
  const [isDynamicVariableSelectionOpen, setIsDynamicVariableSelectionOpen] = useState(false);
  const [demolink, setDemolink] = useState("");
  const [callSubmitted, setCallSubmitted] = useState(false);
  const [connectionDetails, setConnectionDetails] = useState(null);
  const [overrideContext, setOverrideContext] = useState(false);
  const [dynamicVariables, setDynamicVariables] = useState(null);
  const [isFeedbackFormOpen, setIsFeedbackFormOpen] = useState(false);
  const [isOutboundCall, setIsOutboundCall] = useState(false);
  const [ttsConfigId, setTtsConfigId] = useState("default");

  const toggleChatWindow = (agentId, category, subCategory) => {
    setSelectedchatAgent(agentId);
    setShowChatWindow((prevState) => !prevState);
  };

  const { data: dynamicVarsResponse, isLoading: dynamicVarsLoading } = useDynamicVariablesQuery(voiceConfig, isDynamicVariableSelectionOpen);
  const { data: ttsConfigs, isLoading: ttsLoading } = useTtsConfigsQuery({
    baseUrl: voiceConfig?.baseUrl,
    agent_id: voiceConfig?.agent_id
  });

  const handleCloseChatWindow = () => {
    setShowChatWindow(false);
  };

  const handleEndDemo = () => {
    setIsModalOpen(false);
  };

  const startCall = (variables) => {
    setDynamicVariables(variables);
    if (voiceProvider === "outbound-call") {
      submitForm(variables);
    } else {
      setIsCallDialogOpen(true);
      setIsCallActive(true);
    }
  };

  const handleEndCall = () => {
    setIsCallActive(false);
  };

  const submitForm = async (variables) => {
    try {
      //todo: need to add a loading condition here, this order is incorrect as of now
      setCallSubmitted(true);

      const response = await axios.post(voiceConfig.baseUrl + "/voice/outbound-call", {
        number: phoneNumber,
        agent_id: voiceConfig.agent_id,
        overide_previous_context: overrideContext,
        custom_dynamic_variables_config: variables,
      }, {
        headers: {
          "tenant-id": voiceConfig.tenant_id,
          "workspace-id": voiceConfig.workspace_id
        }
      });
      if (response && response.data) {
        console.log("response of outbound-call api: ", response.data)
        setConnectionDetails(response.data);
        // voiceConfig.voiceProvider = "outbound-call"
        setIsOutboundCall(true)
        setIsFeedbackFormOpen(true)
      }
    } catch (error) {
      console.error("Failed to submit call request:", error);
    }
  };

  const handleVoiceSelect = (configId) => {
    setTtsConfigId(configId);
  };

  // Get the selected TTS config for displaying the image
  const selectedTtsConfig = ttsConfigId !== "default"
    ? ttsConfigs?.find(config => config.tts_config_id === ttsConfigId)
    : null;
  const displayImage = selectedTtsConfig?.display_img || icon;
  const displayName = selectedTtsConfig?.display_text || agentName;

  return (
    <div className="text-black">
      <div
        className="agent-card h-full "
        key={id}
        style={{
          background: "linear-gradient(168deg, #BEFF6B 0.88%, #ffffff 30.54%)"
        }}
      >
        <div className="card-content">
          <div className="icon-container gap-6 mb-20">
            <div className="icon-wrapper">
              <div
                style={{
                  width: "150px",
                  height: "110px",
                }}
              >
                <img src={displayImage} alt="Agent Icon" />
                <h5>{displayName}</h5>
              </div>
            </div>
          </div>
          <h3>{name}</h3>

          {/* Voice Selection Dropdown */}
          {ttsConfigs && ttsConfigs.length > 0 && (
            <div className="mb-4 px-4 mt-[15px]">
              <Select onValueChange={handleVoiceSelect} value={ttsConfigId || "default"}>
                <SelectTrigger className="w-full text-black text-lg h-12">
                  <SelectValue placeholder="Select a voice" />
                </SelectTrigger>
                <SelectContent className="text-black text-lg">
                  <SelectGroup>
                    <SelectLabel className="text-black text-lg">Available Voices</SelectLabel>
                    <SelectItem value="default" className="text-black text-lg">Default</SelectItem>
                    {ttsConfigs.map((config) => (
                      <SelectItem key={config.tts_config_id} value={config.tts_config_id} className="text-black text-lg">
                        {config.display_text}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          )}

          {featureList?.length > 0 && (
            <div className="usercontext">
              {featureList.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <CheckCircle
                    style={{
                      opacity: 0.5,
                      width: "15px",
                      height: "15px",
                      flexShrink: 0,
                    }}
                  />
                  <span className="semibold -mt-0.7">{feature}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {voiceInputs.includes("phone") && (
          <div className="mt-5 w-full px-6 pl-2">
            <div className="flex items-center justify-between">
              <label className="pl-[16px] opacity-50" htmlFor="clear-context-switch">Clear previous call history</label>
              <Switch
                id="clear-context-switch"
                checked={overrideContext}
                onCheckedChange={setOverrideContext}
              />
            </div>
          </div>
        )}
        {voiceInputs.includes("phone") && (
          <div className="mt-5 px-6 w-full">
            <PhoneInput
              placeholder="Enter phone number (without code)"
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
            />
          </div>
        )}
        <div className="btn-wrapper">
          {voice === "true" && (
            <div>
              {callSubmitted ? (
                <div className="flex flex-row items-center justify-center gap-1">
                  <Check
                    size={13}
                    strokeWidth={2.4}
                    className="text-green-600"
                  />
                  <span className=" text-gray-600">
                    You'll receive a call soon
                  </span>
                </div>
              ) : (
                <Button
                  className="app-nurix-button flex flex-row items-center justify-center gap-1 hover:bg-blue-800"
                  disabled={
                    !(
                      !voiceInputs.includes("phone") ||
                      (voiceInputs.includes("phone") && phoneNumber.length > 10)
                    )
                  }
                  onClick={voiceProvider === "retell" ? startCall : () => setIsDynamicVariableSelectionOpen(true)}
                >

                  {voiceProvider === "retell" ? (
                    <>
                      <Phone
                        size={11.2}
                        strokeWidth={2.4}
                        className="mt-[2px] opacity-90"
                      />
                      Call
                    </>
                  ) : (
                    "Start"
                  )}
                </Button>
              )}
            </div>
          )}
          {chat === "true" && (
            <button
              className="app-nurix-button flex flex-row items-center justify-center gap-1 hover:bg-blue-800"
              onClick={() => toggleChatWindow(id, categoryKey, name)}
            >
              <MessageSquare
                size={11.2}
                strokeWidth={2.6}
                className="mt-[2px] opacity-90"
              />
              Chat
            </button>
          )}
        </div>
      </div>

      {isModalOpen && (
        <DemoModal
          onClose={handleEndDemo}
          videoId={demovideoId}
          demolink={demolink}
        />
      )}

      {showChatWindow && (
        <ChatWindow
          onClose={handleCloseChatWindow}
          selectedchatAgent={selectedchatAgent}
          name={displayName}
          chatHints={chatHints}
          chatIcon={chatIcon}
          agentId={id}
        />
      )}
      {isDynamicVariableSelectionOpen && !dynamicVarsLoading && (
        Object.keys(dynamicVarsResponse || {}).length > 0 ? (
          <DynamicVariables
            isOpen={true}
            response={dynamicVarsResponse}
            onClose={() => setIsDynamicVariableSelectionOpen(false)}
            onSubmit={startCall}
          />
        ) : (
          (() => {
            setIsDynamicVariableSelectionOpen(false);
            startCall({});
            return null;
          })()
        )
      )}
      {isFeedbackFormOpen && (
        <CallFeedbackForm
          isOpen={isFeedbackFormOpen}
          voiceConfig={voiceConfig}
          call_id={connectionDetails.call_id}
          setIsFeedbackFormOpen={setIsFeedbackFormOpen}
          isCallDialogOpen={isCallDialogOpen}
          setIsCallDialogOpen={setIsCallDialogOpen}
          isOutboundCall={isOutboundCall}
        />
      )}
      {isCallActive &&
        voiceProvider !== "outbound-call" &&
        (voiceProvider === "livekit" ? (
          <LivekitVoice
            isCallDialogOpen={isCallDialogOpen}
            setIsCallDialogOpen={setIsCallDialogOpen}
            name={displayName}
            callHints={callHints}
            callHintsTable={callHintsTable}
            agentName={displayName}
            icon={displayImage}
            ttsConfigId={ttsConfigId !== "default" ? ttsConfigId : null}
            voiceConfig={voiceConfig}
            phoneNumber={phoneNumber}
          />
        ) : voiceProvider === "voicex" ? (
          <VoiceXCallDialog
            isCallDialogOpen={isCallDialogOpen}
            setIsCallDialogOpen={setIsCallDialogOpen}
            name={displayName}
            callHints={callHints}
            callHintsTable={callHintsTable}
            agentName={displayName}
            icon={displayImage}
            voiceConfig={voiceConfig}
            phoneNumber={phoneNumber}
            ttsConfigId={ttsConfigId !== "default" ? ttsConfigId : null}
            dynamicVariables={dynamicVariables}
            isFeedbackFormOpen={isFeedbackFormOpen}
            setIsFeedbackFormOpen={setIsFeedbackFormOpen}
            setConnectionDetails={setConnectionDetails}
          />
        ) : (
          <RetellCallDialog
            onEndCall={handleEndCall}
            name={displayName}
            callHints={callHints}
            callHintsTable={callHintsTable}
            agentName={displayName}
            icon={displayImage}
            agentId={id}
            phoneNumber={phoneNumber}
          />
        ))}
    </div>
  );
}